
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


export default {
components: {
XHeader,
Tab,
TabItem
},
data () {
return {
pageTitle: '发起流程',
baseUrl: this.$store.state.url,
userName: false,
AtdIsActive: true,
FinIsActive: false,
HrIsActive: false
}
},
mounted () {
if(this.$store.state.userInfo.accounts){
this.userName = this.$store.state.userInfo.accounts;
}
},
methods: {
goLogin () {
this.$router.push({ name: 'Login'});
},
changeTab (v) { // 待办事宜-切换tab
if (v === '行政') { // 行政
this.FinIsActive = false;
this.HrIsActive = false;
this.AtdIsActive = true;
} else if (v === '财务') { // 财务
this.AtdIsActive = false;
this.HrIsActive = false;
this.FinIsActive = true;
} else if (v === '人力') { // 人力
this.AtdIsActive = false;
this.FinIsActive = false;
this.HrIsActive = true;
}
},
}
}




// WEBPACK FOOTER //
// ./src/page/Launch.vue